import { Pill } from '@99designs/common/components/Pill';
import { colors, spaces } from '@99designs/common/core/settings';
import { DesignerMeta_User } from '__generated__/DesignerMeta_User';
import Icon from 'launch/components/Icon';
import DesignerMetaHeader from 'projects/components/DesignerMetaHeader';
import ExpandableText from 'projects/components/ExpandableText';
import StatsTable from 'projects/components/StatsTable';
import Box from 'projects/libs/core-components/Box/Box';
import * as React from 'react';
import styled from 'styled-components';

export enum Stat {
    Responsiveness,
    ProjectCount,
    RepeatClients,
}

export interface Props {
    designer: DesignerMeta_User;
    onRemove?: (userId: number) => void;
    hasFullStats?: boolean;
    onClickDescription?: () => void;
    showFullBiography?: boolean;
    highlightNewDesigners?: boolean;
    stats?: Stat[];
}

const Header = styled.div`
    border-bottom: ${spaces.space2}px solid ${colors.t1000};
`;

const DesignerMeta = ({
    designer,
    onRemove,
    onClickDescription,
    showFullBiography = false,
    highlightNewDesigners = true,
    stats = [Stat.Responsiveness, Stat.ProjectCount, Stat.RepeatClients],
}: Props) => {
    const isNewDesigner = highlightNewDesigners && designer.profile.completedProjectsCount == 0;

    return (
        <Box display="flex" flexDirection="column">
            <Header>
                <DesignerMetaHeader
                    designer={designer}
                    onRemove={onRemove}
                    paragraphSize={'small'}
                    avatarSize={'extra-small'}
                />
            </Header>
            {highlightNewDesigners && isNewDesigner && (
                <Box marginTop="space6">
                    <Pill variations={['custom']}>
                        <Icon icon="star-2" /> {__("I'm new here")}
                    </Pill>
                    <div className="paragraph paragraph--small paragraph--soft paragraph--no-margin">
                        {__('Be one of the first to work with this designer')}
                    </div>
                </Box>
            )}

            {!isNewDesigner && stats.length > 0 && (
                <StatsTable>
                    {stats.map(type => {
                        switch (type) {
                            case Stat.RepeatClients:
                                return (
                                    <StatsTable.Stat
                                        amount={designer.profile.repeatCount}
                                        label={__('Repeat clients')}
                                    />
                                );
                            case Stat.ProjectCount:
                                return (
                                    <StatsTable.Stat
                                        amount={designer.profile.completedProjectsCount}
                                        label={__('Projects')}
                                    />
                                );
                            case Stat.Responsiveness:
                                return (
                                    <StatsTable.Stat
                                        amount={`${designer.profile.responsivenessScore}%`}
                                        label={__('Responds within 24 hours')}
                                    />
                                );
                        }
                    })}
                </StatsTable>
            )}

            <Box marginTop="space5">
                {designer.profile.biography.length > 0 && (
                    <ExpandableText
                        onExpand={onClickDescription}
                        text={designer.profile.biography}
                        isExpanded={showFullBiography}
                        expandLabel={__('Full description')}
                    />
                )}
            </Box>
        </Box>
    );
};
export default DesignerMeta;
